<script setup>
import {Avatar} from "vue-avatar";
import {useStore} from "vue2-helpers/vuex";
const defineProps = defineProps(['log']);
const emit = defineEmits(['delete']);

const store = useStore();
</script>

<template>
    <div class="update-section">
        <header class="list-insights__header">
            <Avatar
                :username="log.user_name_for_avatar"
                :src="log.user_avatar"
                :size="30"
                class="activity-item__image"
            />
            
            <h6 class="list-insights__title">{{log.user_name}}</h6>

            <time class="list-insights__time">{{log.time}}</time>

            <b-dropdown id="dropdown-AS2" class="dropdown-original dropdown-original--xs icons-list" variant="link" no-caret>
                <b-dropdown-item
                    v-if="log.user_id === store.state.user.id || store.getters.isAdmin"
                    class="icons-list__delete"
                    @click="emit('delete', log.note.id)"
                >
                    Delete
                </b-dropdown-item>
            </b-dropdown>
        </header>

        <p>
            <v-clamp autoresize :max-lines="5">{{log.note.text}}
                <template #after="{ toggle, expanded, clamped }">
                    <a v-if="expanded" class="link link-normal" @click="toggle"> less</a>
                    <a v-if="clamped" class="link link-normal" @click="toggle"> more</a>
                </template>
            </v-clamp>
        </p>
    </div>
</template>

<script>
    import VClamp from 'vue-clamp'


export default {
    components: {
        VClamp,
    }
}
</script>

<style scoped>

</style>
